import { getAddonDetailsRoute } from "@api-routes/bff";
import { useFetch } from "@common/hook/useFetch";
import { IAddonDetails } from "@features/Addons/interface/IAddonDetails";
import { useCallback, useEffect, useState } from "react";

export const useAddonsPage = () => {
    const [addonDetails, setAddonDetails] = useState<IAddonDetails>();
    const [addonDetailsState, { get }] = useFetch();
    const { isLoading, error } = addonDetailsState;

    const getAddonDetails = useCallback(() => {
        get<IAddonDetails>(getAddonDetailsRoute()).then((addonDetailsResponse) => {
            if (addonDetailsResponse) {
                setAddonDetails(addonDetailsResponse);
            }
        });
    }, [get]);

    useEffect(getAddonDetails, [getAddonDetails]);

    return {
        addonDetails,
        getAddonDetails,
        isLoading,
        error,
    };
};
